import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    meta: { title: '智能问答', requireAuth: true },
    component: () => import('../views/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录' },
    component: () => import('../views/login/login.vue')
  },
  { path: '*', redirect: '/index' }
];

const router = new VueRouter({
  routes,
});

// 加上这一段，处理重复跳转报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  document.title = to.meta && to.meta.title ? to.meta.title + ' - 智能体问答系统' : '智能体问答系统'
  const token = sessionStorage.getItem('token')
  if (to.meta && to.meta.requireAuth && !token) {
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else if (to.path === '/login' && token) {
    next({ path: '/index' })
  } else {
    next()
  }
})

export default router;
